import { AfterViewInit, Component, effect, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs/operators';
import { AccordionState } from './accordion.state';
import { DocumentRefService } from '../services/document-ref.service';
import { environment } from '../../../../environments/environment';
import { ClubApp } from '@aaa/emember/types';

@Component({
  selector: 'ava-accordion',
  template: ` <ng-content /> `,
  standalone: true,
})
export class AccordionComponent implements AfterViewInit {
  private document = inject(DocumentRefService);
  private state = inject(AccordionState);

  activePanelId = input('');
  selectPanel = output<string>();

  constructor() {
    effect(() => {
      this.state.selectedPanelId$.next(this.activePanelId());
    });

    this.state.userClicked
      .pipe(
        tap((selectedPanelId) => this.selectPanel.emit(selectedPanelId)),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  ngAfterViewInit() {
    this.state.selectedPanelId$.next(this.activePanelId());
  }

  onPanelExpanded() {
    // Temporarily enable accordion auto-scroll only for Colorado.
    if (environment.clubId === ClubApp.Colorado) {
      this.document.scrollToId(this.activePanelId());
    }
  }
}
